<template>
  <aside class="wrap-channel-service-time">
    <div class="card">
      <div class="info-attendance">
        <div class="info-attendance-whatsapp">
          <img src="@/assets/icons/texts.svg" alt="Ícone Whatsapp" />
          <span> {{ dataChannelServiceTime.totalAtendimentoMes ? dataChannelServiceTime.totalAtendimentoMes.whatsapp : 0}} </span>
        </div>
        <div class="info-attendance-whatsapp">
          <img src="@/assets/icons/instagram.svg" alt="Ícone Instagram" />
          <span> {{ dataChannelServiceTime.totalAtendimentoMes ? dataChannelServiceTime.totalAtendimentoMes.instagram : 0}} </span>
        </div>
        <div class="info-attendance-whatsapp">
          <img src="@/assets/icons/facebook-messenger.svg" alt="Ícone Facebook" />
          <span> {{ dataChannelServiceTime.totalAtendimentoMes ? dataChannelServiceTime.totalAtendimentoMes.messenger : 0}} </span>
        </div>
        <div class="info-attendance-email">
          <img src="@/assets/icons/e-mail.svg" alt="Ícone E-mail" />
          <span> {{ dataChannelServiceTime.totalAtendimentoMes ? dataChannelServiceTime.totalAtendimentoMes.email : 0}} </span>
        </div>
        <div class="sum-attendance">
          <span>
            {{
              parseInt(dataChannelServiceTime.totalAtendimentoMes ? dataChannelServiceTime.totalAtendimentoMes.whatsapp : 0) + parseInt(dataChannelServiceTime.totalAtendimentoMes ? dataChannelServiceTime.totalAtendimentoMes.email : 0)+ parseInt(dataChannelServiceTime.totalAtendimentoMes ? dataChannelServiceTime.totalAtendimentoMes.instagram : 0)+ parseInt(dataChannelServiceTime.totalAtendimentoMes ? dataChannelServiceTime.totalAtendimentoMes.messenger : 0)
            }}
          </span>
        </div>
      </div>
      <p>
        {{ $t("sectionDashboard.dashboardTotalMes") }}
      </p>
    </div>
    <div class="card">
      <p>
        <img src="@/assets/icons/texts.svg" alt="Ícone Whatsapp" />
        <span>{{ dataChannelServiceTime.totalMedioAtendimentoMes ? dataChannelServiceTime.totalMedioAtendimentoMes.whatsapp : 0}}</span>
      </p>
      <p>
        <img src="@/assets/icons/instagram.svg" alt="Ícone Instagram" />
        <span>{{ dataChannelServiceTime.totalMedioAtendimentoMes ? dataChannelServiceTime.totalMedioAtendimentoMes.instagram : 0}}</span>
      </p>
      <p>
        <img src="@/assets/icons/facebook-messenger.svg" alt="Ícone Facebook" />
        <span>{{ dataChannelServiceTime.totalMedioAtendimentoMes ? dataChannelServiceTime.totalMedioAtendimentoMes.messenger : 0}}</span>
      </p>
      <p>
        <img src="@/assets/icons/e-mail.svg" alt="Ícone E-mail" />
        <span>{{ dataChannelServiceTime.totalMedioAtendimentoMes ? dataChannelServiceTime.totalMedioAtendimentoMes.email : 0}}</span>
      </p>

      <p>{{ $t("sectionDashboard.dashboardTempoMedioMes") }}</p>
    </div>
  </aside>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  name: "ChannelServiceTime",
   computed: {
    ...mapGetters({
      dataChannelServiceTime: "dashboard/getDataChannelServiceTime",
    })
  },
}
</script>

<style lang="scss" scoped>
.wrap-channel-service-time {
  display: flex;
  width: 100%;

  .card {
    flex: auto;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 1rem;

    &:first-child {
      margin-right: 2rem;
    }

    p {
      font-weight: 600;
      font-size: 1rem;
      margin: 0;
      display: flex;
      align-items: center;

      span {
        font-size: 1.4rem;
        font-weight: 700;
        margin-left: 0.5rem;
        padding: 0.4rem 0;
      }
    }
  }
}

.sum-attendance {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  font-size: 1.5rem;
  font-weight: 700;
  margin-left: 0.8rem;

  span {
    color: rgb(57, 173, 227);
    margin-left: 1rem;
  }
}

.info-attendance {
  display: flex;
  align-items: center;
  justify-content: center;

  &-whatsapp {
    margin-right: 2rem;
    position: relative;

    span {
      &:after {
        content: " + ";
        position: absolute;
        right: -1.5rem;
      }
    }
  }

  &-email {
    position: relative;

    span {
      &:after {
        content: " = ";
        position: absolute;
        right: -1rem;
      }
    }
  }

  &-whatsapp,
  &-email {
    display: flex;
    flex-direction: column;
    align-items: center;

    font-size: 1.5rem;
    font-weight: 700;
    img {
      width: 2.2rem;
      height: 2.2rem;
    }
  }
}
</style>
